import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ReactImageZoom from 'react-image-zoom';
import ReactLoading from 'react-loading';
import { useSearchParams } from 'react-router-dom';

const SearchView = () => {
    const [searchParams] = useSearchParams();
    const [products, setProducts] = useState([]);
    const [total, setTotal] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const queryString = searchParams.get('q');
        setLoading(true);

        fetch(`${process.env.REACT_APP_BACKEND_API}/search?q=${queryString}`, {
            method: "GET", mode: 'cors'
        })
            .then((response) => response.json())
            .then((data) => {
                setTotal(data.meta.total);
                setProducts(data.products);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }, [searchParams]);

    return (
        <section className="women-banner spad">
            <Container fluid>
                <Row className="row-cols-3=auto">
                    <Col>
                        <div className="product-card">
                            {loading ? (
                                <ReactLoading type={'bubbles'} color={'#000000'} height={50} width={50} />
                            ) : total === 0 ? (
                                <div className="notfound"><p><h3>Ops, não encontramos...!</h3></p></div>
                            ) : (
                                products.map((product) => (
                                    <div key={product.id} className="product-item">
                                        <div className="pi-pic">
                                            <ReactImageZoom
                                                img={`${process.env.REACT_APP_IMAGE_URL}/${product.id}.jpeg`}
                                                zoomPosition="original"
                                            />
                                        </div>
                                        <div className="pi-text">
                                            <div className="catagory-name">{product.category}</div>
                                            <h5>{product.name}</h5>
                                            <div className="product-price">
                                                R$ {product.price.toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default SearchView;
